<script setup lang="ts">
  import { provide } from 'vue'
  import { agencyKey } from '@gat-ship/types/injection-keys'
  import { useAgency } from '../../composables/useAgency'

  const props = defineProps<{
    agencyId?: string
    fetchOnMount?: boolean
  }>()

  const agency = useAgency()

  if (props.fetchOnMount && props.agencyId) {
    agency.fetchAgency(props.agencyId, { forceFetch: false })
  }

  provide(agencyKey, agency)
  defineExpose(agency)
</script>

<template>
  <slot />
</template>
